import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { Chip, Grid, IconButton, Tooltip } from "@mui/material";

import SortBy from "./Agents";
import pages from "../../../constants/pages";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple};
  color: ${colors.purple};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({ sortBy, setSortBy, templates, loading, agent }) {
  const navigate = useNavigate();
  let columns = [
    {
      name: "name",
      label: "Template Name",
    },

    {
      name: "verified_status_id",
      label: "Template Status",
    },

    { name: "template_header", label: "Template Header Type" },

    { name: "template_body", label: "Template Body" },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "name") {
      return value;
    }

    if (col.name === "template_header") {
      return value?.type;
    }

    if (col.name === "template_body") {
      return value?.text.length > 20
        ? value?.text.substring(0, 20) + "..."
        : value?.text;
    }

    if (col.name === "verified_status_id") {
      let color;
      let label;
      let background;
      if (value === "531c1247d1ca4329b4eef4596a099b52") {
        color = colors.warning;
        background = colors.lightWarning;
        label = "Pending";
      }

      if (value === "8360b5eca314424a9d56c37004ccecc9") {
        color = colors.success;
        background = colors.lightSuccess;
        label = "Approved";
      } else {
        color = colors.error;
        background = colors.lightError;
        label = "Rejected";
      }

      return (
        <Chip
          style={{
            fontSize: "13px",
            backgroundColor: background,
            color: color,
          }}
          label={label}
        />
      );
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Template">
            <Icon>
              <CgEye
                onClick={() =>
                  navigate(
                    pages.templateDetails.route +
                      row._id +
                      "?agent_id=" +
                      row.agent_id
                  )
                }
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar agents={agent} sortBy={sortBy} setSortBy={setSortBy} />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={templates}
        />
      </Grid>
    </Grid>
  );
}

export function ToolBar({ agents, setPage, sortBy, setSortBy }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <SortBy agents={agents} sortBy={sortBy} setSortBy={setSortBy} />
      </div>
    </div>
  );
}
